import React, { Component } from "react";
import DashboardLayout from "../../UI/Layout/DashboardLayout";
import Title from "../../UI/Text/Title";
import Card from "../../UI/Card/Card";
import WhatsAppPreview from "../whatsapp/components/WhatsAppPreview";
import ReactTelInput from "react-telephone-input";
import flags from "../../Dashboard/assets/img/flags.png";
import { WHATSAPP_TEMPLATE_LIST } from "../../../constants/ServiceConstants";
import api from "../../../axios/Axios";
import { no_data } from "../../../images/WhatsAppImages";
import Alert from "../../UI/Alert/Alert";
import { HOST_URL, REQUEST_URL } from "../api/Api";
import { WhstappAccountList } from "../../Dashboard/api/Api";
import Axios from "../../../axios/Axios";
import WhatsAppCarouselPreview from "./components/WhatsappCarouselPreview";
import Select from "react-select";
import { handleUserLog } from "../../Utils/Utils";

class SendWhatsappMessageSingle extends Component {
    constructor() {
        const lStorage = JSON.parse(localStorage.getItem("login"));
        const userId = lStorage?.user?.userId;
        const userToken = lStorage?.token;
        super();

        this.state = {
            user_id: userId,
            token: userToken,
            recipientNumber: "",
            authkey: "",
            UserDetails: "",
            templatePreView: "",
            showButton: false,
            WhatsAppTemplate: [],
            wid: "",
            message: "",
            successMessage: false,
            errorMessage: "",
            bgColor: "",
            defaultCountry: "in",
            countryCode: "",
            whatsapplimittotal: "",
            showLimits: false,
            route: '',
            file: null,
            paramData: [],
            paramHeaderData: [],
            formData: {},
            formHeaderData: {},
            url: '',
            fileName: '',
            headerVariable: { headerFileName: "", headerData: "" },
            disableButton: false,
            presentImage: '',
            isPresentChecked: true,
            isNewChecked: false,
            TemplateType: '',
            countryList: [],
            couponCode: '',
            lto: '',
            filterSelectedTemplate: []
        };
    }

    handlePresentChange = () => {
        this.setState((prevState) => ({
            isPresentChecked: !prevState.isPresentChecked
        }));
        this.setState({ isNewChecked: false })
    };

    handleNewChange = () => {
        this.setState((prevState) => ({
            isNewChecked: !prevState.isNewChecked
        }));
        this.setState({ isPresentChecked: false })
    };

    getRoute = async () => {
        try {
            let paramData = {
                user_id: this.state.user_id,
                method: "retrieve",
                token: this.state.token
            }
            let { data } = await Axios.post(`${HOST_URL}/get_user_route.php`, paramData)
            if (data.success) {
                this.setState({ route: data.data })
            }

        } catch (error) {
            console.log(error)
        }

    }

    componentDidMount() {
        this.getTemplateList();
        this.getRoute();
        this.getUserDetails();
        this.fetchCountryCode();
        let paramData = {
            user_id: this.state.user_id,
            token: this.state.token,
            method: "retrieve",
        }
        WhstappAccountList(paramData).then((res) => {
            if (res.data.data === undefined) {
                this.setState({ showLimits: true });
            } else {
                this.setState({ showLimits: false });
            }
        });
    }

    fetchCountryCode = async () => {
        const payload = {
            user_id: this.state.user_id,
            token: this.state.token,
            method: "retrieve",
        }

        try {
            const { data } = await Axios.post(`${HOST_URL}/user_pricelist.php`, payload);
            if (data.success) {
                // console.log(data.data)
                let countryData = data.data
                let filterCode = countryData.map((x) => ({
                    label: x.country_name,
                    value: x.country_code,
                }));
                this.setState({ countryList: filterCode });
            }
            else {
                this.setState({ countryList: [] });
            }

        } catch (error) {
            this.setState({
                errorMessage: "error in fetching country list, please try again later",
                successMessage: true,
                bgColor: "alert alert-danger alert-dismissible",
            });

        }
    }

    getTemplateList = () => {
        let paramData = {
            user_id: this.state.user_id,
            token: this.state.token,
            method: "retrieve",
        };

        WhstappAccountList(paramData).then((res) => {
            if (res.data.data === undefined) {
                // First POST API call for retrieve_for_test
                Axios.post(`${HOST_URL}/whatsapp_template.php`, {
                    user_id: this.state.user_id,
                    method: "retrieve_for_test",
                    token: this.state.token
                })
                    .then((response) => {
                        let result = response.data;
                        if (result.success === true) {
                            result.data.forEach((item) => {
                                if (item.temp_status === 1) {
                                    this.setState((prevState) => ({
                                        WhatsAppTemplate: [...prevState.WhatsAppTemplate, item],
                                    }));
                                }
                            });
                        } else {
                            this.setState({
                                successMessage: true,
                                bgColor: "alert alert-danger alert-dismissible",
                                errorMessage: result.message,
                            });
                        }
                    })
                    .catch((error) => {
                        console.error("Error fetching templates (retrieve_for_test):", error);
                    });

            } else {
                // Second POST API call for retrieve
                Axios.post(`${HOST_URL}/whatsapp_template.php`, {
                    user_id: this.state.user_id,
                    method: "retrieve",
                    token: this.state.token
                })
                    .then((response) => {
                        let result = response.data;
                        if (result.success === true) {
                            result.data.forEach((item) => {
                                if (item.temp_status === 1) {
                                    this.setState((prevState) => ({
                                        WhatsAppTemplate: [...prevState.WhatsAppTemplate, item],
                                    }));
                                }
                            });
                        } else {
                            this.setState({
                                successMessage: true,
                                bgColor: "alert alert-danger alert-dismissible",
                                errorMessage: result.message,
                            });
                        }
                    })
                    .catch((error) => {
                        console.error("Error fetching templates (retrieve):", error);
                    });
            }
        });
    };


    getUserDetails = async () => {
        let paramData = {
            user_id: this.state.user_id,
            method: "retrieve",
            token: this.state.token
        }
        let { data } = await Axios.post(`${HOST_URL}/profile.php`, paramData)
        if (data.success === true) {
            const userDetails = data.data[0];
            const testwhatsapplimit = userDetails.test_whatsapp_limit1 || 0;
            const testwhatsappsent = userDetails.test_whatsapp_sent || 0;
            const desiredParameterValue = Math.max(
                testwhatsapplimit - testwhatsappsent,
                0
            );

            this.setState({
                UserDetails: userDetails,
                testwhatsapplimits: testwhatsapplimit,
                test_whatsapp_sent: testwhatsappsent,
                desiredParameterValue: desiredParameterValue.toString(),
            });
        } else {
            this.setState({
                successMessage: true,
                bgColor: "alert alert-danger alert-dismissible",
                errorMessage: data.message,
            });
        }
    };

    updatetextwhatsapplimit = async () => {
        let params = {
            user_id: this.state.user_id,
            method: "update_limit",
            token: this.state.token
        }

        let { data } = await Axios.post(`${HOST_URL}/profile.php`, params)
        if (data.success === true) {
            this.getUserDetails();
        } else {
            console.error(
                "Failed to update WhatsApp template limit:",
                data.message
            );
        }
    };







    selectedTemplate = async (e) => {
        this.setState({ wid: e.target.value });

        const filterTemplate = this.state.WhatsAppTemplate.filter(x => x.id == e.target.value);
        let presentData = JSON.parse(filterTemplate[0].temp_header)
        let templateHeaderData = JSON.parse(filterTemplate[0]?.temp_header)
        console.log(filterTemplate);


        const bodyVariables = filterTemplate[0].temp_body.match(/{{([^}]+)}}/g);
        this.setState({ filterSelectedTemplate: filterTemplate, bodyVar: bodyVariables, presentImage: presentData?.image ? presentData?.image : presentData?.video ? presentData?.video : presentData?.document, TemplateType: filterTemplate[0]?.temp_type })
        this.extractData(filterTemplate[0].temp_body);
        this.extractHeaderVariable(templateHeaderData?.text)
        // this.setState({ });

        if (filterTemplate[0]?.temp_type === "Text") {
            this.setState({ isPresentChecked: false })
        }
        else {
            this.setState({ isPresentChecked: true })
        }

        try {
            const { data } = await api.post(WHATSAPP_TEMPLATE_LIST, {
                token: this.state.token,
                user_id: this.state.user_id,
                id: e.target.value,
                method: "retrieveid",
            });
            let urlbtn = [];
            let urlbtn2 = [];
            let callbtn = [];
            let button1 = [];
            let button2 = [];
            let button3 = [];
            let button4 = [];
            let button5 = [];
            let button6 = [];
            let button7 = [];
            if (data.success === true) {
                if (data.data[0].temp_button) {
                    let buttonData = data?.data[0]?.temp_button;
                    // if (data.data[0].temp_type === "Carousel") {
                    //     let buttonCards = buttonData.cards
                    //     buttonCards.forEach((x) => {
                    //         x.components.forEach((items) => {
                    //             let data = items.button;
                    //             if (data && typeof data === 'string') {
                    //                 if (data.includes("urltext2")) {
                    //                     urlbtn2[0] = items.button;
                    //                 }
                    //                 if (data.includes("urltext")) {
                    //                     urlbtn[0] = items.button;
                    //                 }
                    //                 if (data.includes("phone_number")) {
                    //                     callbtn[0] = items.button;
                    //                 }
                    //                 if (data.includes("button1")) {
                    //                     button1[0] = items.button;
                    //                 }
                    //                 if (data.includes("button2")) {
                    //                     button2[0] = items.button;
                    //                 }
                    //                 if (data.includes("button3")) {
                    //                     button3[0] = items.button;
                    //                 }
                    //             }
                    //         });
                    //     });

                    // }
                    // else {
                    //     buttonData.map((item, index) => {
                    //         let key = Object.keys(item);
                    //         if (key.includes("urltext2")) {
                    //             urlbtn2[0] = item;
                    //         }
                    //         if (key.includes("urltext")) {
                    //             urlbtn[0] = item;
                    //         }
                    //         if (key.includes("phone")) {
                    //             callbtn[0] = item;
                    //         }
                    //         if (key.includes("button1")) {
                    //             button1[0] = item;
                    //         }
                    //         if (key.includes("button2")) {
                    //             button2[0] = item;
                    //         }
                    //         if (key.includes("button3")) {
                    //             button3[0] = item;
                    //         }
                    //         if (key.includes("button4")) {
                    //             button4[0] = item;
                    //         }
                    //         if (key.includes("button5")) {
                    //             button5[0] = item;
                    //         }
                    //         if (key.includes("button6")) {
                    //             button6[0] = item;
                    //         }
                    //         if (key.includes("button7")) {
                    //             button7[0] = item;
                    //         }
                    //     });
                    // }
                    buttonData.map((item, index) => {
                        let key = Object.keys(item);
                        if (key.includes("urltext2")) {
                            urlbtn2[0] = item;
                        }
                        if (key.includes("urltext")) {
                            urlbtn[0] = item;
                        }
                        if (key.includes("phone")) {
                            callbtn[0] = item;
                        }
                        if (key.includes("button1")) {
                            button1[0] = item;
                        }
                        if (key.includes("button2")) {
                            button2[0] = item;
                        }
                        if (key.includes("button3")) {
                            button3[0] = item;
                        }
                        if (key.includes("button4")) {
                            button4[0] = item;
                        }
                        if (key.includes("button5")) {
                            button5[0] = item;
                        }
                        if (key.includes("button6")) {
                            button6[0] = item;
                        }
                        if (key.includes("button7")) {
                            button7[0] = item;
                        }
                    });
                }

                let PreviewTemplateData = {
                    tampleName: data.data[0].temp_name,
                    language: data.data[0].temp_language,
                    accountType: data.data[0].temp_category,
                    templateType: data.data[0].temp_type,
                    headerText: data.data[0].temp_header,
                    headerOptions: data.data[0].temp_header === "" ? false : true,
                    footerText: data.data[0].temp_footer,
                    footerOptions: data.data[0].temp_header === "" ? false : true,
                    temp_button: data.data[0].temp_button,
                    bodyMessage: data.data[0].temp_body,
                    button: data.data[0].temp_button,
                    temp_status: data.data[0].temp_status,
                    Urlbutton: urlbtn,
                    Urlbutton2: urlbtn2,
                    Callbutton: callbtn,
                    button1: button1,
                    button2: button2,
                    button3: button3,
                    button4: button4,
                    button5: button5,
                    button6: button6,
                    button7: button7,
                    quickButton:
                        data.data[0].temp_button.length > 0 &&
                            data.data[0].temp_button[0].actionType === "quickReply"
                            ? [data.data[0].temp_button[0]]
                            : "",
                    temp_attribute: [],
                    isLoading: false,
                };
                this.setState({ templatePreView: PreviewTemplateData });
            }
        } catch (err) {
            console.log(err);
        }
    };

    sendWhatsAppTestMessage = async () => {
        this.setState({ disableButton: true });
        try {
            // Set isLoading to true
            this.setState({ setIsLoading: true });

            // Check if Recipient Mobile Number exists and is valid
            if (!this.state.recipientNumber.trim()) {
                // If not exists or is empty, show an error message
                this.setState({
                    errorMessage: "Recipient Mobile Number is required.",
                    successMessage: false,
                    bgColor: "alert alert-danger alert-dismissible",
                });
                return;
            } else {
                // Validate the mobile number using a regular expression
                const mobileNumberRegex = /^[0-9]{10}$/; // Adjust the regex based on your validation criteria

                if (!mobileNumberRegex.test(this.state.recipientNumber.trim())) {
                    // If the mobile number is not valid, show an error message
                    this.setState({
                        errorMessage: "Please enter a valid 10-digit mobile number.",
                        successMessage: false,
                        bgColor: "alert alert-danger alert-dismissible",
                    });
                    return;
                }
            }

            // Check if WhatsApp Template is selected
            if (!this.state.wid) {
                this.setState({
                    errorMessage: "Please select a WhatsApp Template.",
                    successMessage: false,
                    bgColor: "alert alert-danger alert-dismissible",
                });
                return;
            }

            let param = {}

            // Prepare the data to be sent to the API
            if (this.state.TemplateType === 'Text') {
                if (this.state.formHeaderData) {
                    param = {
                        mobile: this.state.recipientNumber,
                        wid: this.state.wid,
                        country_code: this.state.countryCode.value,
                        type: this.state.TemplateType,
                        bodyValues: this.state.formData,
                        header_param_value: this.state.formHeaderData,
                        copy_code_value: this.state.couponCode,
                        expiration_time_ms: this.state.lto
                    };
                }
                else {
                    param = {
                        mobile: this.state.recipientNumber,
                        wid: this.state.wid,
                        country_code: this.state.countryCode.value,
                        type: this.state.TemplateType,
                        bodyValues: this.state.formData,
                        copy_code_value: this.state.couponCode,
                        expiration_time_ms: this.state.lto
                    };
                }
            }
            else {
                param = {
                    mobile: this.state.recipientNumber,
                    wid: this.state.wid,
                    country_code: this.state.countryCode.value,
                    type: this.state.TemplateType,
                    bodyValues: this.state.formData,
                    copy_code_value: this.state.couponCode,
                    expiration_time_ms: this.state.lto,
                    headerValues: this.state.isPresentChecked ? { headerData: this.state.presentImage, headerFileName: "image" } : this.state.isNewChecked ? this.state.headerVariable : { headerData: "", headerFileName: "" },
                };
            }

            // Fetch WhatsApp account list
            let paramData = {
                user_id: this.state.user_id,
                token: this.state.token,
                method: "retrieve",
            }
            const res = await WhstappAccountList(paramData);

            let authkey = "";
            let response = null;

            if (res.data.data === undefined) {
                response = await fetch("https://console.authkey.io/restapi/requestjson.php", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=UTF-8",
                        'Authorization': `Basic 523912703d2967f9`,
                    },
                    body: JSON.stringify(param),
                });
            } else {
                authkey = this.state.UserDetails.authkey;
                response = await fetch("https://console.authkey.io/restapi/requestjson.php", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=UTF-8",
                        'Authorization': `Basic ${authkey}`,
                    },
                    body: JSON.stringify(param),
                });
            }

            // Ensure we get a valid response
            if (!response.ok) {
                throw new Error('Failed to send the message');
            }

            const result = await response.json();

            // Update the text message limit
            this.updatetextwhatsapplimit();

            // Scroll to the top of the page
            window.scrollTo(0, 0);

            // Set the success or error state based on the response
            if (result.status === "Success") {
                this.setState({
                    errorMessage: result.Message,
                    successMessage: true,
                    bgColor: "alert alert-success alert-dismissible",
                    recipientNumber: "",
                    wid: "",
                    paramData: [],
                    formData: {},
                    headerVariable: {},
                    file: null,
                    disableButton: false
                });
                handleUserLog("", "send_test_message", "whatsapp", "whatsapp " + result.Message, "send_whatsapp", "", param)

                setTimeout(() => {
                    this.props.history.push("/dashboard/whatsapp-report");
                }, 3000);
            } else {
                this.setState({
                    errorMessage: "Failed to send message. Please try again.",
                    successMessage: false,
                    bgColor: "alert alert-danger alert-dismissible",
                });
                handleUserLog("", "send_test_message", "whatsapp", result.Message, "send_whatsapp", "", param)
            }

        } catch (error) {
            console.error(error);
            this.setState({
                errorMessage: "An error occurred. Please try again.",
                successMessage: false,
                bgColor: "alert alert-danger alert-dismissible",
            });
                handleUserLog("", "send_test_message", "whatsapp", error.response.result.Message, "send_whatsapp", "", "")
        } finally {
            // Set isLoading to false
            this.setState({ setIsLoading: false });
        }
    };

    extractData = (data) => {
        const pattern = /{{([^}]+)}}/g;
        const matches = [];
        let match;
        while ((match = pattern.exec(data)) !== null) {
            matches.push(match[1]);
        }
        this.setState({ paramData: matches })
        return matches;
    };

    extractHeaderVariable = (data) => {
        const pattern = /{{([^}]+)}}/g;
        const matches = [];
        let match;
        while ((match = pattern.exec(data)) !== null) {
            matches.push(match[1]);
        }
        this.setState({ paramHeaderData: matches })
        return matches;
    };

    handleFileChange = (event) => {
        const selectedFile = event?.target?.files[0];

        if (selectedFile) {
            const fileType = selectedFile.type;

            if (
                fileType === 'image/jpeg' ||
                fileType === 'image/png' ||
                fileType === 'application/pdf' ||
                fileType === 'video/mp4' ||
                fileType === 'video/avi' ||
                fileType === 'video/mkv'
            ) {
                this.setState({ file: selectedFile });
            } else {
                alert("Please upload an image (jpg, jpeg, png) or a PDF file.");
                this.setState({ file: null });
            }
        }

        const parts = selectedFile.name.split('.');
        const mediaName = parts.slice(0, parts.length - 1).join('.');
        const mediaType = parts[parts.length - 1];


        const data = new FormData();
        data.append("amdfile", selectedFile);
        data.append("doc_name", mediaName);
        data.append("doc_type", mediaType);
        data.append("user_id", this.state.user_id);
        data.append("token", this.state.token);
        data.append("method", "create");
        fetch(`${HOST_URL}/uploadFileWhatsapp.php`, {
            method: "POST",
            body: data,
        }).then((result) => {
            result.json().then((resp) => {
                // console.log("resp", resp);
                if (resp.success === true) {
                    this.setState({
                        url: resp.url,
                        fileName: mediaName,
                        headerVariable: { headerFileName: mediaName, headerData: resp.url }
                    });
                    //   this.setState({
                    //     isError: true,
                    //     errorMessage: resp.message,
                    //     messageType: "alert-success",
                    //   });
                    //   this.getWhatsaAppMediaGallery();
                } else {
                    //   this.setState({
                    //     isError: true,
                    //     errorMessage: resp.message,
                    //     messageType: "alert-danger",
                    //   });
                }
            });
        });
    };

    ChangeHeaderVariable = (event) => {
        this.setState({ formHeaderData: event.target.value })
    };

    ChangeVariable = (event) => {
        const { name, value } = event.target;
        this.setState((prevState) => ({
            formData: {
                ...prevState.formData,
                [name]: value,
            },
        }));
    };

    customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: "pointer",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (style) => ({
            ...style,
            fontSize: "12px",
        }),
    };


    handleCountryChange = (selectedOption) => {
        this.setState({ countryCode: selectedOption });
    };

    render() {
        const { defaultCountry, showLimits } = this.state;
        const { testwhatsapplimits, test_whatsapp_sent } = this.state;
        // console.log(this.state.WhatsAppTemplate);

        // console.log(this.state.countryCode);
        // console.log(this.state.wid);



        return (
            <DashboardLayout>
                <main className="content">
                    <div className="container-fluid p-0">
                        <Title> WhatsApp </Title>
                        <div className="row">
                            <div className="col-md-8">
                                {this.state.successMessage && (
                                    <Alert type={this.state.bgColor}>
                                        {this.state.errorMessage}
                                    </Alert>
                                )}

                                <Card CardTitle={`Send test message on whatsApp`}>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label
                                                    for="colFormLabel"
                                                    className="col-form-label"
                                                >
                                                    Select WhatsApp Template
                                                </label>
                                                <div className="input-group drop-down-icons mb-2">
                                                    <select
                                                        value={this.state.wid}
                                                        onChange={this.selectedTemplate}
                                                        className="form-control"
                                                    >
                                                        <option value="">Select Template</option>
                                                        {this.state.WhatsAppTemplate.map((item, index) => (
                                                            <option key={index} value={item.id}>
                                                                {item.temp_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {/* <Select
                                                            onChange={this.selectedTemplate}
                                                            options={this.state.WhatsAppTemplate}
                                                            value={this.state.wid}
                                                            isSearchable={true}
                                                            placeholder="Select Template"
                                                            isClearable={true}
                                                            styles={this.customStyles}
                                                        // isDisabled={this.state.updateId ? true : false}
                                                        /> */}
                                                </div>
                                                {showLimits && (
                                                    <div className="form-group">
                                                        {/* ... (rest of your form-group code) */}
                                                        <p className="text-sm">
                                                            Current Sent Limit:{" "}
                                                            <span className="text-success">
                                                                {testwhatsapplimits}
                                                            </span>
                                                        </p>
                                                        <p className="text-sm mb-0">
                                                            Used Sent Limit:{" "}
                                                            <span className="text-danger">
                                                                {test_whatsapp_sent}
                                                            </span>
                                                        </p>
                                                        {testwhatsapplimits == test_whatsapp_sent && (
                                                            <span className="alert alert-danger mt-3 mb-0">
                                                                Please Contact the Person
                                                            </span>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>


                                        {this.state.paramHeaderData.map((item, x) => (
                                            <div className="input-group mb-2 mr-sm-2" key={x}>
                                                <div className="input-group-text w-25">
                                                    headerVariable
                                                </div>
                                                <input type="text" name={item} placeholder={`Enter headerVariable`} onChange={this.ChangeHeaderVariable} className="form-control" />
                                            </div>
                                        ))}

                                        {this.state.paramData.map((item, x) => (
                                            <div className="input-group mb-2 mr-sm-2" key={x}>
                                                <div className="input-group-text w-25">
                                                    {`{{${item}}}`}
                                                </div>
                                                <input type="text" name={item} placeholder={`Enter {{${item}}}`} onChange={this.ChangeVariable} className="form-control" />
                                            </div>
                                        ))}

                                        {this.state.TemplateType === 'Media' ?
                                            <div className="checkbox-container">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        checked={this.state.isPresentChecked}
                                                        onChange={this.handlePresentChange}
                                                    />
                                                    <span className="ml-1">Use Existing File</span>
                                                </label>
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        className="ml-3"
                                                        checked={this.state.isNewChecked}
                                                        onChange={this.handleNewChange}
                                                    />
                                                    <span className="ml-1">Upload New Media File</span>
                                                </label>
                                            </div> : null}


                                        {this.state.isPresentChecked && this.state.templatePreView && this.state.TemplateType === 'Media' ?
                                            <div className="row mb-2">
                                                <div className="col-12">
                                                    <input type="text" className="form-control" value={this.state.presentImage} />
                                                </div>
                                            </div>
                                            : null}

                                        {this.state.isNewChecked &&
                                            <div className="input-group mb-2 mt-4 mr-sm-2">
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text">Image/Document Upload</div>
                                                </div>
                                                <input
                                                    type="file"
                                                    name="file"
                                                    accept=".jpg, .jpeg, .png, .pdf, .mp4, .avi, .mkv"
                                                    onChange={this.handleFileChange}
                                                    className="form-control"
                                                />

                                            </div>}

                                        {this?.state?.filterSelectedTemplate[0]?.coupon_code === 1 &&
                                            <div className="row">
                                                <div className="col-6">
                                                    <input type="text" className="form-control" value={this.state.couponCode} onChange={(e) => this.setState({ couponCode: e.target.value })} placeholder="Enter Coupon Code" />
                                                </div>
                                                {this?.state?.filterSelectedTemplate[0]?.lto_type === 1 &&
                                                    <div className="col-6">
                                                        <input type="text" className="form-control" value={this.state.lto} onChange={(e) => this.setState({ lto: e.target.value })} placeholder="Enter Limited Time Offer" />
                                                        <span style={{ fontSize: "10px", color: "black" }}>Date.now() + (3 * 24 * 60 * 60 * 1000) Eg:1767177600000</span>
                                                    </div>}
                                            </div>}

                                        {this?.state?.filterSelectedTemplate[0]?.lto_type === 1 &&
                                            <div className="row">
                                                <span className="ml-3 mt-2" style={{ fontSize: "12px", color: "red" }}>Maximum 16 characters for the offer text (the short text that appears above the offer timer).</span>
                                                {/* <div className="col-6">
                                                    <input type="text" className="form-control" value={this.state.couponCode} onChange={(e) => this.setState({ couponCode: e.target.value })} placeholder="Enter Coupon Code" />
                                                </div> */}
                                            </div>
                                        }


                                        <div className="row">
                                            <div className="col-sm-12">
                                                <label for="colFormLabel" className="col-form-label">
                                                    Recipient Mobile Number
                                                </label>

                                                <div className="row">
                                                    <div className="col-4">
                                                        <Select
                                                            onChange={this.handleCountryChange}
                                                            options={this.state.countryList}
                                                            value={this.state.countryCode}
                                                            isSearchable={true}
                                                            placeholder="Select Country"
                                                            isClearable={true}
                                                            styles={this.customStyles}
                                                        // isDisabled={this.state.updateId ? true : false}
                                                        />
                                                    </div>
                                                    <div className="col-8">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={this.state.recipientNumber}
                                                            onChange={(event) =>
                                                                this.setState({
                                                                    recipientNumber: event.target.value,
                                                                })
                                                            }
                                                            id="inlineFormInputGroup"
                                                            placeholder="Enter whatsApp Number"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {showLimits ? (
                                        <button
                                            type="button"
                                            onClick={() => this.sendWhatsAppTestMessage()}
                                            className="btn btn-sm button-cus"
                                            disabled={
                                                this.state.testwhatsapplimits ===
                                                    this.state.test_whatsapp_sent || this.state.disableButton ? true : false
                                            }
                                        >
                                            Send
                                        </button>
                                    ) : (<button
                                        type="button"
                                        onClick={() => this.sendWhatsAppTestMessage()}
                                        className="btn btn-sm button-cus"
                                        disabled={this.state.disableButton ? true : false}
                                    >
                                        Send
                                    </button>)}

                                </Card>
                            </div>

                            <div className="col-md-4 ">
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="card-title mb-0"> Template Preview </h5>
                                    </div>
                                    <hr className="m-0" />
                                    <div className="card-body">
                                        {this.state.templatePreView ? (
                                            // this.state.TemplateType == "Carousel" ?
                                            //     <WhatsAppCarouselPreview
                                            //         previewData={this.state.templatePreView}
                                            //         route={this.state.route}
                                            //     />
                                            //     :
                                            //     <WhatsAppPreview
                                            //         previewData={this.state.templatePreView}
                                            //         route={this.state.route}
                                            //     />
                                            <WhatsAppPreview
                                                previewData={this.state.templatePreView}
                                                route={this.state.route}
                                            />

                                        ) : (
                                            <div className="text-center">
                                                <img className="img-fluid" src={no_data} />
                                                <p className="text-right">
                                                    Please select WhatsApp Templte to preview
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </DashboardLayout>
        );
    }
}

export default SendWhatsappMessageSingle;
